



















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SubNavigationCard extends Vue {

    get componentClasses(): object {
        return {
            'new-navigation-submenu-card': true,
        }
    }
}

